
import Vue from 'vue'

/**
 * This component is deprecated.
 * Consider using Overlay.vue and Modal.vue.
 */
export default Vue.extend({
  props: {
    closeBtn: {
      type: Boolean,
      default: true
    },
    persistent: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasHeader(): boolean {
      return !!this.$slots.header
    },
    hasFooter(): boolean {
      return !!this.$slots.footer
    }
  },
  mounted(): void {
    document.querySelector('body')!.classList.add('is-locked')
  },
  destroyed(): void {
    document.querySelector('body')!.classList.remove('is-locked')
  },
  methods: {
    closeModal(): void {
      this.$emit('closeModal')
    }
  }
})
